import { Nav } from '../components/Nav'
import { Link } from 'react-router-dom'

export default function Terms() {
  const lastUpdated = 'January 2, 2026'

  return (
    <div className="page">
      <div className="page-header">
        <Link to="/settings" style={{ color: 'var(--color-primary)', textDecoration: 'none', fontSize: '0.875rem' }}>
          ← Back to Settings
        </Link>
        <h1 className="page-title" style={{ marginTop: '0.5rem' }}>Terms of Service</h1>
        <p style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>
          Last updated: {lastUpdated}
        </p>
      </div>

      <div className="page-content" style={{ paddingBottom: '100px' }}>
        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Agreement to Terms</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            By accessing or using Reframer at presentlens.app ("the Service"), you agree to be bound
            by these Terms of Service. If you do not agree to these terms, please do not use the Service.
          </p>
        </div>

        <div className="card" style={{
          marginBottom: '1rem',
          borderLeft: '3px solid var(--color-error)',
          backgroundColor: 'rgba(239, 68, 68, 0.05)'
        }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem', color: 'var(--color-error)' }}>
            Important Medical Disclaimer
          </h2>
          <p style={{ color: 'var(--color-text)', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '0.75rem' }}>
            <strong>Reframer is NOT:</strong>
          </p>
          <ul style={{ color: 'var(--color-text)', fontSize: '0.875rem', lineHeight: 1.8, paddingLeft: '1.25rem', marginBottom: '0.75rem' }}>
            <li>A substitute for professional mental health treatment</li>
            <li>A medical device</li>
            <li>Therapy or counseling</li>
            <li>A diagnostic tool</li>
            <li>Emergency crisis intervention</li>
          </ul>
          <p style={{ color: 'var(--color-text)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            Reframer is a self-help tool for practicing cognitive reframing techniques.
            If you are experiencing a mental health crisis, please contact emergency services (911),
            the 988 Suicide & Crisis Lifeline, or a licensed mental health professional immediately.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>The Service</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '0.75rem' }}>
            Reframer provides:
          </p>
          <ul style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.8, paddingLeft: '1.25rem' }}>
            <li>AI-assisted cognitive reframing based on CBT principles</li>
            <li>Voice and text input for describing thoughts and situations</li>
            <li>Session history and emotional progress tracking</li>
            <li>Educational information about cognitive distortions</li>
            <li>Crisis resource information when concerning language is detected</li>
          </ul>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Eligibility</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            You must be at least 13 years of age to use Reframer. If you are under 18, you should
            review these terms with a parent or guardian. By using the Service, you represent that
            you meet these requirements.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Your Responsibilities</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '0.75rem' }}>
            When using Reframer, you agree to:
          </p>
          <ul style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.8, paddingLeft: '1.25rem' }}>
            <li>Use the Service only for its intended purpose of cognitive reframing practice</li>
            <li>Not rely on the Service as a replacement for professional mental health care</li>
            <li>Seek professional help if you are experiencing severe distress or crisis</li>
            <li>Not use the Service to harm yourself or others</li>
            <li>Not attempt to reverse-engineer, hack, or disrupt the Service</li>
            <li>Not use the Service to generate harmful, illegal, or abusive content</li>
          </ul>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>AI-Generated Content</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '0.75rem' }}>
            Reframer uses artificial intelligence to generate reframes and insights. You understand that:
          </p>
          <ul style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.8, paddingLeft: '1.25rem' }}>
            <li>AI-generated content may not always be accurate, appropriate, or helpful</li>
            <li>The AI does not understand your complete situation or history</li>
            <li>Reframes are suggestions for consideration, not professional advice</li>
            <li>You should use your own judgment about whether suggestions are helpful</li>
          </ul>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Your Content</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            You retain ownership of the thoughts, text, and recordings you submit to Reframer.
            By using the Service, you grant us a limited license to process your content to provide
            the Service. We do not claim ownership of your content or use it for purposes beyond
            providing and improving the Service for you.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Privacy</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            Your use of Reframer is also governed by our{' '}
            <Link to="/privacy" style={{ color: 'var(--color-primary)' }}>Privacy Policy</Link>,
            which describes how we collect, use, and protect your information.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Availability & Changes</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            We strive to keep Reframer available, but we do not guarantee uninterrupted access.
            We may modify, suspend, or discontinue any part of the Service at any time.
            We may also update these Terms, and continued use after changes constitutes acceptance.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Limitation of Liability</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '0.75rem' }}>
            To the maximum extent permitted by law:
          </p>
          <ul style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.8, paddingLeft: '1.25rem' }}>
            <li>Reframer is provided "as is" without warranties of any kind</li>
            <li>We are not liable for any damages arising from your use of the Service</li>
            <li>We are not responsible for decisions you make based on the Service</li>
            <li>Our total liability shall not exceed the amount you paid to use the Service (if any)</li>
          </ul>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Indemnification</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            You agree to indemnify and hold harmless Reframer and its operators from any claims,
            damages, or expenses arising from your use of the Service or violation of these Terms.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Termination</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            You may stop using Reframer at any time and delete your data through Settings.
            We may terminate or suspend your access if you violate these Terms or for any other
            reason at our discretion.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Governing Law</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            These Terms are governed by the laws of the United States. Any disputes shall be
            resolved in the courts of the United States.
          </p>
        </div>

        <div className="card" style={{ marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Contact</h2>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>
            If you have questions about these Terms, please contact us at:{' '}
            <a
              href="mailto:legal@presentlens.app"
              style={{ color: 'var(--color-primary)' }}
            >
              legal@presentlens.app
            </a>
          </p>
        </div>

        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: 'var(--color-text-muted)',
          fontSize: '0.75rem'
        }}>
          By using Reframer, you acknowledge that you have read and agree to these Terms of Service.
        </div>
      </div>

      <Nav />
    </div>
  )
}
